import { Typography } from '@mui/material';

import { ContentContainer, ContentImageContainer, ContentRightContainer, ContentRightTextContainer, StyledButton } from './styled';

type IconTextButtonProps = Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'children'> & {
  text?: string;
  icon?: React.ReactNode;
  typoVarient?: 'h6' | 'h14';
};

export default function IconTextButton({ type = 'button', icon, text, typoVarient = 'h6', ...remainder }: IconTextButtonProps) {
  return (
    <StyledButton {...remainder} type={type}>
      <ContentContainer>
        <ContentImageContainer>{icon}</ContentImageContainer>
        <ContentRightContainer>
          <ContentRightTextContainer>
            <Typography variant={typoVarient}>{text}</Typography>
          </ContentRightTextContainer>
        </ContentRightContainer>
      </ContentContainer>
    </StyledButton>
  );
}
